<template>
  <nav class="menu-container">
    <h3><font color="#9950B2">5号线</font></h3>
    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
  </nav>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  components: {
    Icon,
  },
  data() {
    return {
      items: [
        {
          name: "chiwan",
          title: "赤湾",
          // icon: "chat",
          exact: true,
        },
        {
          name: "liwan",
          title: "荔湾",
          // icon: "chat",
          exact: true,
        },
        {
          name: "tielugongyuan",
          title: "铁路公园",
          // icon: "chat",
          exact: true,
        },
        {
          name: "mawan",
          title: "妈湾",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qianwangongyuan",
          title: "前湾公园",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qianwan",
          title: "前湾",
          // icon: "chat",
          exact: true,
        },
        {
          name: "guiwan",
          title: "桂湾",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qianhaiwan",
          title: "前海湾",
          // icon: "chat",
          exact: true,
        },
        {
          name: "linhai",
          title: "临海",
          // icon: "chat",
          exact: true,
        },
        {
          name: "baohua",
          title: "宝华",
          // icon: "chat",
          exact: true,
        },
        {
          name: "baoanzhongxin",
          title: "宝安中心",
          // icon: "chat",
          exact: true,
        },
        {
          name: "fanshen",
          title: "翻身",
          // icon: "chat",
          exact: true,
        },
        {
          name: "lingzhi",
          title: "灵芝",
          // icon: "chat",
          exact: true,
        },
        {
          name: "honglangbei",
          title: "洪浪北",
          // icon: "chat",
          exact: true,
        },
        {
          name: "xingdong",
          title: "兴东",
          // icon: "chat",
          exact: true,
        },
        {
          name: "liuxiandong",
          title: "留仙洞",
          // icon: "chat",
          exact: true,
        },
        {
          name: "xili",
          title: "西丽",
          // icon: "chat",
          exact: true,
        },
        {
          name: "daxuecheng",
          title: "大学城",
          // icon: "chat",
          exact: true,
        },
        {
          name: "tanglang",
          title: "塘朗",
          // icon: "chat",
          exact: true,
        },
        {
          name: "changlingpi",
          title: "长岭陂",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shenzhenbei",
          title: "深圳北",
          // icon: "chat",
          exact: true,
        },
        {
          name: "minzhi",
          title: "民治",
          // icon: "chat",
          exact: true,
        },
        {
          name: "wuhe",
          title: "五和",
          // icon: "chat",
          exact: true,
        },
        {
          name: "bantian",
          title: "坂田",
          // icon: "chat",
          exact: true,
        },
        {
          name: "yangmei",
          title: "杨美",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shangshuijing",
          title: "上水径",
          // icon: "chat",
          exact: true,
        },
        {
          name: "xiashuijing",
          title: "下水径",
          // icon: "chat",
          exact: true,
        },
        {
          name: "changlong",
          title: "长龙",
          // icon: "chat",
          exact: true,
        },
        {
          name: "buji2",
          title: "布吉",
          // icon: "chat",
          exact: true,
        },
        {
          name: "baigelong",
          title: "百鸽笼",
          // icon: "chat",
          exact: true,
        },
        {
          name: "buxin",
          title: "布心",
          // icon: "chat",
          exact: true,
        },
        {
          name: "taian",
          title: "太安",
          // icon: "chat",
          exact: true,
        },
        {
          name: "yijing",
          title: "怡景",
          // icon: "chat",
          exact: true,
        },
        {
          name: "huangbeiling",
          title: "黄贝岭",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(67, 47, 221);
    }
  }
}
</style>





<!-- <template>
  <div>
    <h3>
        首页<br><br>
深圳地铁1号线 途经站点 共30站<br><br>
注：高峰期发车间隔为4分钟，平峰期为6分钟<br><br>

罗湖站-国贸站-老街站-大剧院站-科学馆站-华强路站-岗厦站-会展中心站-购物公园站-香蜜湖站-车公庙站-竹子林站-侨城东站-华侨城站-世界之窗站-白石洲站-高新园站-深大站-桃园站-大新站-鲤鱼门站-前海湾站-新安站-宝安中心站- 宝体站-坪洲站-西乡站-固戍站-后瑞站-机场东站
    </h3>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style> -->